export default String.raw`
<div class="main-content-container__attributes {% if product.Archival == true -%} archival {% endif -%}">
    {% assign attributesSize = 0 -%}
    {% assign attributesLimit = 9 -%}

    {% comment -%}<!-- Manufacturer Name -->{% endcomment -%}
    {% if product.Manufacturer.Name != '' and product.Manufacturer and settings.productDetailsManufacturer == 'productDetailsManufacturer-yes' and attributesSize < attributesLimit -%}
        <div class="attribute">
            {{ translations.Manufacturer }}: <a href="{{ page.BaseHref }}{{ product.Manufacturer.Url }}"><strong>{{ product.Manufacturer.Name }}</strong></a>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- Brand Name -->{% endcomment -%}
    {% if product.Brand.Name != '' and product.Brand and settings.productDetailsBrand == 'productDetailsBrand-yes' and attributesSize < attributesLimit -%}
        <div class="attribute">
            {{ translations.Brand }}: <a href="{{ page.BaseHref }}{{ product.Brand.Url }}"><strong>{{ product.Brand.Name }}</strong></a>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- VAT -->{% endcomment -%}
    {% if activeProduct.VAT != null and attributesSize < attributesLimit -%}
        <div class="attribute">
            {{ translations.VatTax }}: <strong>{{ activeProduct.VAT }}%</strong>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- Ean Codes-->{% endcomment -%}
    {% if settings.eanCodes == 'eanCodes-no' and activeProduct.UPC != '' and attributesSize < attributesLimit -%}
        <div class="attribute">
            {{ translations.EanCode }}: <strong>{{ activeProduct.UPC }}</strong>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% else -%}
        {% assign eanCodes = activeProduct.EanCodes -%}
        {% assign eanCodesStringOutput = '' -%}
        {% assign eanPhantomStringOutput = '' -%}
        {% assign unitSpecificEanCount = 0 -%}
        {% for ean in eanCodes -%}
            {% if ean.Id == unitId -%}
                {% assign unitSpecificEanCount = unitSpecificEanCount | Plus: 1 -%}
                {% if eanCodesStringOutput !='' -%}
                    {% assign eanCodesStringOutput = eanCodesStringOutput | Append:',<br>' -%}
                {% endif -%}
                {% capture eanCodesStringOutput -%}{{eanCodesStringOutput}}<strong>{{ean.Code}}</strong>{% endcapture -%}
                {% assign attributesSize = attributesSize | Plus: 1 -%}
            {% endif -%}
            {% if eanPhantomStringOutput !='' -%}
                {% assign eanPhantomStringOutput = eanPhantomStringOutput | Append:',' -%}
            {% endif -%}
            {% if ean.Id == null -%}
                {% assign eanId = 'null' -%}
            {% else -%}
                {% assign eanId = ean.Id -%}
            {% endif -%}
            {% capture eanPhantomStringOutput -%}{{eanPhantomStringOutput}}{{ean.Code}}|{{eanId}}{% endcapture -%}
        {% endfor -%}
        {% if activeProduct.UPC != '' or eanCodesStringOutput != '' and attributesSize < attributesLimit -%}
            <div class="attribute">
                {% if activeProduct.UPC != '' -%}
                    {% if eanCodesStringOutput != '' -%}
                        {% assign multipleEans = true -%}
                    {% else -%}
                        {% assign multipleEans = false -%}
                    {% endif -%}
                {% else -%}
                    {% if unitSpecificEanCount == 1 -%}
                        {% assign multipleEans = false -%}
                    {% else -%}
                        {% assign multipleEans = true -%}
                    {% endif -%}
                {% endif -%}
                <span class="one-ean-js {% if multipleEans -%} hidden-js {% endif -%}">{{ translations.EanCode }}:</span>
                <span class="multiple-ean-js {% if multipleEans == false -%} hidden-js {% endif -%}">{{ translations.EanCodes }}:</span>
                <span class="ean-js">
                    {% if activeProduct.UPC != '' -%}
                        <strong>{{ activeProduct.UPC }}</strong>{% if eanCodesStringOutput != '' -%},<br>{{ eanCodesStringOutput }}{% endif -%}
                        {% assign attributesSize = attributesSize | Plus: 1 -%}
                    {% else -%}
                        {{ eanCodesStringOutput }}
                        {% assign attributesSize = attributesSize | Plus: 1 -%}
                    {% endif -%}
                </span>
            </div>
        {% endif -%}
    {% endif -%}

    {% comment -%}<!-- Manufacturer Code -->{% endcomment -%}
    {% if product.ManufacturerCode != '' and attributesSize < attributesLimit -%}
        <div class="attribute">
            {{ translations.ManufacturerCode }}: <strong>{{ product.ManufacturerCode }}</strong>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- CN Code -->{% endcomment -%}
    {% if product.CN != '' and attributesSize < attributesLimit -%}
        <div class="attribute">
            {{ translations.CnCode }}: <strong>{{ product.CN }}</strong>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- Symbol -->{% endcomment -%}
    {% if activeProduct.Symbol != '' and attributesSize < attributesLimit -%}
        <div class="attribute">
            {{ translations.Symbol }}: <strong>{{ activeProduct.Symbol }}</strong>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- Weight -->{% endcomment -%}
    {% if activeProduct.Weight != '' and activeProduct.Weight > 0 and attributesSize < attributesLimit -%}
        <div class="attribute">
            {{ translations.Weight }}: <strong>{{ activeProduct.Weight | Normalize | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: 4 }}{{ translations.Kg }}</strong>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- Net Weight -->{% endcomment -%}
    {% if activeProduct.NetWeight != '' and activeProduct.NetWeight > 0 and attributesSize < attributesLimit -%}
        <div class="attribute">
            {{ translations.NetWeight }}: <strong>{{ activeProduct.NetWeight | Normalize | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: 4 }}{{ translations.Kg }}</strong>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- Waste Management Cost -->{% endcomment -%}
    {% if activeProduct.WasteMgmtCost != 0  and attributesSize < attributesLimit -%}
        <div class="attribute">
            {{ translations.WasteMgmtCost }}: <strong>{{ activeProduct.WasteMgmtCost | Normalize }} {{ currencyExt }}</strong>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- Attributes -->{% endcomment -%}
    {% assign is360AttrSet = false -%}
    {% for attribute in activeProduct.Attributes -%}
        {% if attribute.Value != 0 and attribute.Value != "" -%}
            {% assign hideAttr = false -%}
            {% assign attributeName = attribute.Name | Downcase -%}
            {% if attributeName contains '360photo' and is360AttrSet == false -%}
                {% assign hideAttr = true -%}
                {% assign is360AttrSet = true -%}
                <input type="hidden" id="photoLink" value="{{attribute.Value}}">
            {% endif -%}
            {% if hideAttr == false and attributesSize < attributesLimit -%}
                <div class="attribute">
                    {{ attribute.Name }}:
                    {% if attribute.Format == 2 and attribute.Value contains '.' -%}
                        {% assign valueSize = attribute.Value | Size -%}
                        {% assign normalizedValue = attribute.Value -%}
                        {% for character in (1..valueSize) -%}
                            {% assign last = normalizedValue | Last -%}
                            {% if last == '0' or last == '.' -%}
                                {% assign toCut = normalizedValue | Size | Minus: 1 -%}
                                {% assign normalizedValue = normalizedValue | Truncate: toCut,'' -%}
                            {% endif -%}
                            {% if last == '.' -%}
                                {% break -%}
                            {% endif -%}
                        {% endfor -%}
                        <strong>{{ normalizedValue }}</strong> 
                    {% else -%}
                        <strong>{{ attribute.Value }}</strong>
                    {% endif -%}
                </div>
            {% endif -%}
                {% assign attributesSize = attributesSize | Plus: 1 -%}
        {% endif -%}
    {% endfor -%}

    {% comment -%}<!-- Dimensions Height -->{% endcomment -%}
    {% if unitDimensions != null and unitDimensions.Height > 0 or unitDimensions.Width == 0 or attributesSize >= attributesLimit-%}
        <div class="attribute dimensions-height">
            {{ translations.Height }}: <strong>{{unitDimensions.Height }} cm</strong>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- Dimensions Length -->{% endcomment -%}
    {% if unitDimensions != null and unitDimensions.Length > 0 or unitDimensions.Width == 0 or attributesSize >= attributesLimit -%}
        <div class="attribute dimensions-length">
            {{ translations.Length }}: <strong>{{unitDimensions.Length}} cm</strong>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- Dimensions Width -->{% endcomment -%}
    {% if unitDimensions != null and unitDimensions.Width > 0 or unitDimensions.Width == 0 or attributesSize >= attributesLimit -%}
        <div class="attribute dimensions-width">
            {{ translations.Width }}: <strong>{{unitDimensions.Width}} cm</strong>
        </div>
        {% assign attributesSize = attributesSize | Plus: 1 -%}
    {% endif -%}

    {% comment -%}<!-- If more than 9 attributes then show 'see full description' button -->{% endcomment -%}
    {% if attributesSize > attributesLimit -%}
        <div class="pure-button" data-scroll-to-paragraph=".product-attributes-js">
            {{ translations.SeeFullDescription }}
            <svg width="24" height="24">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-down-{{settings.iconStyle}}"></use>
            </svg>
        </div>
    {% endif -%}
</div>
`